import { useState } from "react";
import { getCoreRowModel, getSortedRowModel, useReactTable, type SortingState } from "@tanstack/react-table";

import { DataTable } from "@/components/data-table";
import type { ListResponse } from "@/types/lists.types";
import { featuredColumns } from "./featured-columns";
import { cityDisplayName } from "./group-by-city";

export function FeaturedCityTable({ cityKey, lists }: { cityKey: string; lists: ListResponse[] }) {
  const [sorting, setSorting] = useState<SortingState>([{ id: "createdAt", desc: true }]);
  const table = useReactTable({
    data: lists,
    columns: featuredColumns,
    state: { sorting },
    onSortingChange: setSorting,
    getRowId: (r) => r.id,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });
  return (
    <section aria-labelledby={`city-${cityKey}`} className="flex flex-col gap-2">
      <h2 id={`city-${cityKey}`} className="font-display text-xl font-medium">
        {cityDisplayName(cityKey)}{" "}
        <span className="text-[13px] font-sans text-muted-foreground">{lists.length} {lists.length === 1 ? "list" : "lists"}</span>
      </h2>
      <DataTable table={table} />
    </section>
  );
}
